module.exports = __webpack_public_path__ + "static/media/marker_temporary_bus_stop_red_hover.892e112c.svg";